import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import {
  StorageKeys,
  clearBrowserStorage,
  readStorage,
} from "../auth/browserStorage";

export default function LoggedOut() {
  // Read before clearing so an affiliate user's "sign in again" returns to the branded page.
  const [affiliateSlug] = useState(() =>
    readStorage("session", StorageKeys.affiliateSlug)
  );

  useEffect(() => {
    // Clear any residual storage, including the MSAL cache, to prevent auto-login.
    clearBrowserStorage();
  }, []);

  const signInHref = affiliateSlug
    ? `/login?affiliate=${encodeURIComponent(affiliateSlug)}`
    : "/login";

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        gap: 2,
        p: 3,
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        You've been successfully logged out
      </Typography>
      <Button variant="contained" href={signInHref}>
        Sign in again
      </Button>
    </Box>
  );
}
